import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonMuiTable, { Table } from "../../Component/Table/Table";
import { delete_icon, edit_icon } from "../../assets/img";
import Footer from "../../Component/Footer/Footer";
import { deletes, get, patch } from "../../Services/ApiHandler";
import { ICON_FILTER, URLS } from "../../Services/Constant";
import Loader from "../../Component/Loader";
import CustomScroll from "../../Component/CustomScroll";
import useStoreKv from "../redux/store/useStorekv";
import useStore from "../redux/store/useStore";
import { MaskIcon } from "../../Component/MaskIcon";

const AdminList = () => {
  const navigate = useNavigate();


  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [popup, setPopup] = useState(false);
  const [userId, setuserId] = useState(null);
  const { user } = useStore();

  // IMPORTANT — loader for row-wise status
  const [loadingId, setLoadingId] = useState(null);

  const { kv, set } = useStoreKv();
  const admins = kv.admin_list;
  const [owners, setOwners] = useState(admins ?? []);

  const getList = async () => {
    if (!kv.admin_list || kv.admin_list.length === 0) {
      setLoading(true);
    }
    const res = await get(URLS.ADMINLIST);
    if (res.status === "success") {
      setOwners(res?.data);
      set("admin_list", res.data);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const handleStatus = async (id) => {
    setLoadingId(id); // show loader for that row only

    const res = await patch(`${URLS.ADMINLIST}/${id}/status`);

    if (res.status === "success") {
      await getList();
    }

    setLoadingId(null); // hide loader after API
  };

  const handleDelete = async () => {
    setLoading1(true);
    const id = userId;
    const res = await deletes(`${URLS.ADMINLIST}/${id}`);

    if (res.status === "success") {
      setPopup(false);
      getList();
    }
    setLoading1(false);
  };


  const columns = React.useMemo(
    () => [
      {
        id: "adminIdIndex",
        Header: () => (
          <div className="text-center">
            Admin <br /> ID
          </div>
        ),
        accessor: "id", // you can keep or remove this, not used now
        Cell: ({ row }) => (
          <p className="ac-text">{row.index + 1}</p>
        ),
      },

      {
        id: "adminName",
        Header: () => (
          <div className="text-center">
            Admin <br /> Name
          </div>
        ),
        accessor: "name",
        Cell: ({ value }) => <p className="ac-text">{value}</p>,
      },
      {
        id: "Mobile No",
        Header: () => <div className="text-center">Mobile No</div>,
        accessor: "mobile",
        Cell: ({ value }) => <p className="ac-text">{value}</p>,
      },
      {
        Header: "Role",
        accessor: "role",
        Cell: ({ value, row }) => {
          const data = row.original?.is_super_admin ? "Super Admin" : "Admin";
          return <p className="text-nowrap ac-text">{data}</p>;
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          const id = row.original.id;

          return (
            <div className="d-flex ac-jc">
              {row.original.is_super_admin ? (
                <span className="d-flex ac-jc">-</span>
              ) : (
                <button
                  onClick={() => handleStatus(id)}
                  className={`${value === false ? "deactive-btn" : "active-icon"
                    } 
                    border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
                >
                  {loadingId === id ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", width: 10, height: 10 }}
                    ></span>
                  ) : value === false ? (
                    "Deactive"
                  ) : (
                    "Active"
                  )}
                </button>
              )}
            </div>
          );
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ row }) => {
          return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>

              {user?.is_super_admin === true ? (
                <button
                  onClick={() => navigate("/admin-add", { state: { type: "edit", data: row.original } })}
                  className="cust-btn"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, margin: 0, lineHeight: 1, background: 'none', border: 'none' }}
                >
                  <MaskIcon src={edit_icon} alt="" className="editor-btn" style={{ width: 18, height: 18, display: 'block' }} />
                </button>
              ) : (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 18, height: 18, lineHeight: 1 }}>-</span>
              )}

              {row.original.is_super_admin !== true && (
                <button
                  onClick={() => { setPopup(true); setuserId(row?.original?.id); }}
                  className="cust-btn"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, margin: 0, lineHeight: 1, background: 'none', border: 'none' }}
                >
                  <img src={delete_icon} alt="" style={{ width: 18, height: 18, objectFit: 'contain', display: 'block' }} />
                </button>
              )}

            </div>
          );
        },
      },
    ],
    [loadingId] // important to update loader in UI
  );

  return (
    <div style={{ marginBottom: 25 }} className="dashRightView">
      <CustomScroll >
        <div style={{ paddingTop: 0 }} className="container_overalls">
          <div className="d-flex ae-je">
            <button
              onClick={() => navigate("/admin-add", { state: { type: "add" } })}
              className="f3 my-2 fs-sm-10 fs-md-12 fs-lg-15 fs-xl-16 fs-xxl-18 add-btn sec"
            >
              Add
            </button>
          </div>

          <Table
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={owners ?? []}
            show={false}
            loading={loading}
          />
        </div>

        {popup && (
          <div className="img-popup-design">
            <div className="img-popup">
              <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                Are you sure you want to Delete?
              </p>
              <div
                style={{ paddingTop: 20 }}
                className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                <button onClick={() => setPopup(false)} className="no-btn w-40">
                  No
                </button>
                <button
                  onClick={handleDelete}
                  className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                >
                  {loading1 ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white" }}
                    ></span>
                  ) : (
                    "Yes"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
      </CustomScroll>
    </div>
  );
};

export default AdminList;
